<ng-select
  [(ngModel)]="selectedItem"
  [items]="items"
  [placeholder]="placeholder"
  [searchable]="searchable"
  [clearable]="clearable"
  [ngModelOptions]="{ standalone: true }"
  (change)="valueChange.emit($event)">
</ng-select>
